import { render, staticRenderFns } from "./WelcomeToNectios.vue?vue&type=template&id=0780a96e&scoped=true"
import script from "./WelcomeToNectios.vue?vue&type=script&lang=js"
export * from "./WelcomeToNectios.vue?vue&type=script&lang=js"
import style0 from "./WelcomeToNectios.vue?vue&type=style&index=0&id=0780a96e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0780a96e",
  null
  
)

export default component.exports